import React from "react";
import { styled, keyframes } from "@mui/material/styles";
import Box from "@mui/material/Box";

import {
  AnimationDot,
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "@brandclub/common-ui";
import { useMediaQuery } from "@mui/material";

const ErrorDot = () => {
  const mobileView = useMediaQuery(`(max-width: ${MOBILE_SCREEN_SIZE}px)`);
  return (
    <AnimationDot
      size={mobileView ? 6.6 : 8}
      topOffset={mobileView ? 0 : 2}
      rightOffset={mobileView ? 0 : 2}
      color={"error"}
    />
  );
};

const SveContainer = styled("svg")(({ theme }) => ({
  width: 19,
  height: 19,
  transition: "fill 0.3s ease-in-out",
  fill: theme.vars.palette.text.primary,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    width: 12,
    height: 12,
  },

  "&.active": {
    fill: theme.vars.palette.primary.contrastText,
  },
}));

const IconStore = ({ active }: { active: boolean }) => {
  return (
    <SveContainer
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.517 12"
      className={active ? "active" : ""}
    >
      <path
        data-name="paper-plane (2)"
        d="M12 .385a.371.371 0 0
      0-.03-.145.321.321 0 0 0-.01-.031.368.368 0 0 0-.095-.121c-.006
      0-.014-.006-.02-.011s-.005-.007-.008-.01-.018 0-.026-.008a.367.367 0 0
      0-.346-.014h-.011L.2 5.9a.373.373 0 0 0 .039.68L3.923 8l.711 3.7c0
      .01.008.019.011.029a.4.4 0 0 0 .017.046.382.382 0 0 0
      .048.08c.006.007.008.017.015.024s.009 0 .012.009a.371.371 0 0 0
      .116.084h.007a.366.366 0 0 0 .109.028H5a.372.372 0 0 0 .122-.022c.011 0
      .021-.01.032-.015a.36.36 0 0 0 .08-.048c.005 0 .012-.005.017-.01l2.7-2.421
      2.668.961a.439.439 0 0 0 .127.02.379.379 0 0 0 .2-.058.374.374 0 0 0
      .172-.282L12 .412V.385zM5.127 10.3l-.47-2.446 4.608-4.593-3.324
      5.011a.376.376 0 0 0-.036.069z"
        transform="translate(-.001 -.008)"
      />
    </SveContainer>
  );
};

const IconWallet = ({ active }: { active: boolean }) => {
  return (
    <SveContainer
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.119 12.119"
      className={active ? "active" : ""}
    >
      <g data-name="Group 23554">
        <path
          data-name="Path 26268"
          d="M280.153 218.741a1.167 1.167 0 1 0 1.1 1.165 1.136 1.136 0 0 0-1.1-1.165zm4.014 0a1.167 1.167 0 1 0 1.1 1.165 1.136 1.136 0 0 0-1.1-1.165zm-6.537-9.041s.483 5.213.668 7.063a1.533 1.533 0 0 0 1.492 1.419h5.105a1.512 1.512 0 0 0 1.43-1.108l1.662-5.56a.333.333 0 0 0-.044-.283.3.3 0 0 0-.242-.129h-9.358l-.137-1.745a.307.307 0 0 0-.3-.291H276.3a.317.317 0 0 0 0 .634zm4.954 2.837a2.109 2.109 0 1 0 1.993 2.106 2.052 2.052 0 0 0-1.994-2.102zm-.283 1.39-.017.707a.322.322 0 0 0 .143.278l.617.4a.291.291 0 0 0 .413-.1.328.328 0 0 0-.1-.436l-.47-.306.013-.526a.3.3 0 1 0-.6-.016z"
          transform="translate(-276 -209.071)"
          style={{ fillRule: "evenodd" }}
        />
      </g>
    </SveContainer>
  );
};

const IconShipping = ({ active }: { active: boolean }) => {
  return (
    <SveContainer
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11 12.19"
      className={active ? "active" : ""}
    >
      <path
        data-name="Path 26252"
        d="M284.735 297.87a2.525 2.525 0 1 0 2.525 2.525 2.525 2.525 0 0 0-2.525-2.525zm1.44 2.107-1.517 1.594a.445.445 0 0 1-.32.138.445.445 0 0 1-.32-.135l-.805-.83a.445.445 0 1 1 .639-.62l.483.5 1.2-1.258a.445.445 0 0 1 .645.613z"
        transform="translate(-275.994 -290.92)"
      />
      <path
        data-name="Path 26253"
        d="M21.107 9.484a3.3 3.3 0 0 1 5.085-2.77c0-.244.006-.505.006-.786a29.663 29.663 0 0 0-.146-3.284A2.762 2.762 0 0 0 24.247.3l-.078-.023a2.794 2.794 0 0 0-.6-.131h-.019A15.736 15.736 0 0 0 21.008 0a17.8 17.8 0 0 0-2.682.145h-.019a2.787 2.787 0 0 0-.628.141V.277A2.8 2.8 0 0 0 15.8 2.638a29.694 29.694 0 0 0-.147 3.29 29.685 29.685 0 0 0 .147 3.29 2.8 2.8 0 0 0 2.5 2.5h.019a15.586 15.586 0 0 0 2.542.145c.543 0 .935-.007 1.245-.019a3.287 3.287 0 0 1-.992-2.358zm-1.215-6.975h3.892a.558.558 0 0 1 0 1.116h-3.892a.558.558 0 0 1 0-1.116zm0 3.5a.558.558 0 0 1 0-1.116h1.391a.558.558 0 0 1 0 1.116zm-1.828-2.384a.558.558 0 1 1 .558-.558.558.558 0 0 1-.558.558zm0 2.388a.558.558 0 1 1 .558-.558.558.558 0 0 1-.558.558z"
        transform="translate(-15.65)"
      />
    </SveContainer>
  );
};

const IconBox = ({ active }: { active: boolean }) => {
  return (
    <SveContainer
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.263 12.119"
      className={active ? "active" : ""}
    >
      <path
        data-name="Path 25724"
        d="M4.547 9.532a1.029 1.029 0 0 1-.374-.07L1.267 8.334v1.894a.359.359 0 0 0 .238.338l4.3 1.549V8.386l-.367.631a1.036 1.036 0 0 1-.891.515z"
      />
      <path
        data-name="Path 25725"
        d="M7.717 9.532a1.036 1.036 0 0 1-.893-.514l-.3-.514v3.615l4.312-1.553a.359.359 0 0 0 .238-.338V8.304L8.09 9.462a1.028 1.028 0 0 1-.373.07z"
      />
      <path
        data-name="Path 25726"
        d="M3.684 4.469a3.162 3.162 0 0 1-.51-.877l-.957.345z"
      />
      <path
        data-name="Path 25727"
        d="m10.048 3.934-.96-.352a3.161 3.161 0 0 1-.513.886z"
      />
      <path
        data-name="Path 25728"
        d="m12.218 6.697-1.192-2.081a.338.338 0 0 0-.409-.15L6.132 6.09 1.646 4.465a.338.338 0 0 0-.409.15L.049 6.69A.35.35 0 0 0 0 6.879a.339.339 0 0 0 .216.3l4.208 1.633a.338.338 0 0 0 .415-.145l1.293-2.313 1.293 2.313a.338.338 0 0 0 .415.145l4.208-1.633a.338.338 0 0 0 .171-.483z"
      />
      <path
        data-name="Path 25729"
        d="M6.132 4.931a2.466 2.466 0 1 0-2.466-2.466 2.469 2.469 0 0 0 2.466 2.466zm-1.02-2.088a.36.36 0 0 1 .508-.508l.2.2.834-.834a.36.36 0 1 1 .508.508l-1.086 1.09a.359.359 0 0 1-.508 0z"
      />
    </SveContainer>
  );
};

const BAR_HEIGHT_DESKTOP = 5;
const BAR_HEIGHT_MOBILE = 4;

const ICON_SIZE_DESKTOP = 40;
const ICON_SIZE_MOBILE = 24;

// Styled components for the progress tracker
const ProgressContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1000px",
  margin: "0px auto",
  position: "relative",
}));

const ProgressBar = styled(Box)(({ theme }) => ({
  width: `calc(100% - ${ICON_SIZE_DESKTOP}px)`,
  height: BAR_HEIGHT_DESKTOP,
  backgroundColor: "#e8e8ed",
  position: "absolute",
  top: "50%",
  margin: `0 ${ICON_SIZE_DESKTOP / 2}px`,
  transform: `translateY(-50%)`,
  zIndex: 1,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    width: `calc(100% - ${ICON_SIZE_MOBILE}px)`,
    height: BAR_HEIGHT_MOBILE,
    margin: `0 ${ICON_SIZE_MOBILE / 2}px`,
  },
}));

// Define interface for the props
interface ProgressCompletedProps {
  progress: number;
}

const ProgressCompleted = styled(Box)<ProgressCompletedProps>(
  ({ theme, progress }) => ({
    position: "absolute",
    height: BAR_HEIGHT_DESKTOP,
    backgroundColor: theme.vars.palette.primary.main,
    top: "50%",
    transform: `translateY(-50%)`,
    width: `calc(${progress}% - ${ICON_SIZE_DESKTOP / 2}px)`,
    marginLeft: `${ICON_SIZE_DESKTOP / 2}px`,
    zIndex: 2,
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      height: BAR_HEIGHT_MOBILE,
      width: `calc(${progress}% - ${ICON_SIZE_MOBILE / 2}px)`,
      marginLeft: `${ICON_SIZE_MOBILE / 2}px`,
    },
  })
);

// Animation for the progress pulse - revised to work correctly with each segment
const progressPulse = keyframes`
  0% {
    opacity: 0;
    transform: scaleX(1) translateY(-50%);
    transform-origin: right;
  }

  66% {
    opacity: .85;
  }

  100% {
    opacity: 1;
    transform: scaleX(0) translateY(-50%);
    transform-origin: right;
  }
`;

// Define interface for animation props
interface ProgressAnimationProps {
  activeStep: number;
}

// Animated progress indicator - adjusted to support multiple active steps
const ProgressAnimation = styled(Box)<ProgressAnimationProps>(
  ({ theme, activeStep }) => {
    // Calculate the segment width - for example if on step 2 of 4, each segment is 33.3%
    const totalSteps = 4;
    const segmentWidth = 100 / (totalSteps - 1);

    // Position based on active step
    const startPosition = (activeStep - 1) * segmentWidth;
    // End position is where the next step would be
    const endPosition = Math.min(activeStep * segmentWidth, 100);
    // Width is just the difference between end and start
    const width = endPosition - startPosition;

    return {
      borderRadius: "99px",
      position: "absolute",
      height: BAR_HEIGHT_DESKTOP,
      top: "50%",
      transform: `translateY(-50%)`,
      left: `${startPosition}%`,
      width: `calc(${width}% - ${ICON_SIZE_DESKTOP / 2}px)`,
      zIndex: 2,
      backgroundColor: theme.vars.palette.primary.main,
      animation: `${progressPulse} 3.5s cubic-bezier(0.25, 1, 0.5, 1) infinite`,
      marginLeft: `${
        ICON_SIZE_DESKTOP / 2 / (activeStep > 0 ? activeStep : 0)
      }px`,

      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
      [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        height: BAR_HEIGHT_MOBILE,
        width: `calc(${width}% - ${ICON_SIZE_MOBILE / 2}px)`,
        marginLeft: `${
          ICON_SIZE_MOBILE / 2 / (activeStep > 0 ? activeStep : 0)
        }px`,
      },
    };
  }
);

const ProgressSteps = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  position: "relative",
  zIndex: 3,
}));

// Define interface for Step props
interface StepProps {
  active: boolean;
}

const Step = styled(Box)<StepProps>(({ theme, active }) => ({
  width: ICON_SIZE_DESKTOP,
  position: "relative",
  height: ICON_SIZE_DESKTOP,
  borderRadius: "50%",
  backgroundColor: active ? theme.vars.palette.primary.main : "#e8e8ed",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  transition: "all 0.3s ease-in-out",

  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    width: ICON_SIZE_MOBILE,
    height: ICON_SIZE_MOBILE,
  },
}));

// Define interface for component props
interface ProgressTrackerProps {
  activeStep?: number;
  errorStep?: number;
  animate?: boolean;
}

// Progress Tracker Component

const StepContainer = ({
  active,
  error,
  children,
}: {
  active: boolean;
  error: boolean;
  children: React.ReactNode;
}) => {
  return (
    <Step active={active}>
      {error && <ErrorDot />}
      {children}
    </Step>
  );
};

const ProgressTracker: React.FC<ProgressTrackerProps> = ({
  activeStep = 1,
  errorStep = 0,
  animate = true,
}) => {
  // Calculate progress percentage
  const progressPercentage = ((activeStep - 1) / 3) * 100;

  // Show animation for any active step except the last one (4)
  const showAnimation =
    activeStep > 0 && activeStep < 4 && animate && errorStep === 0;

  return (
    <ProgressContainer>
      <ProgressBar />
      <ProgressCompleted progress={progressPercentage} />
      {showAnimation && <ProgressAnimation activeStep={activeStep} />}
      <ProgressSteps>
        <StepContainer active={activeStep >= 1} error={errorStep === 1}>
          <IconStore active={activeStep >= 1} />
        </StepContainer>
        <StepContainer active={activeStep >= 2} error={errorStep === 2}>
          <IconWallet active={activeStep >= 2} />
        </StepContainer>
        <StepContainer active={activeStep >= 3} error={errorStep === 3}>
          <IconShipping active={activeStep >= 3} />
        </StepContainer>
        <StepContainer active={activeStep >= 4} error={errorStep === 4}>
          <IconBox active={activeStep >= 4} />
        </StepContainer>
      </ProgressSteps>
    </ProgressContainer>
  );
};

export default ProgressTracker;
